module.exports = __webpack_public_path__ + "img/horizontal_blue-white.21b511cb.svg";